import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminFocusGroup from "@/pages/AdminFocusGroup";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/focus-group")({
  head: () => seoHead("/admin/focus-group"),
  component: () => (
    <AdminGate><AdminFocusGroup /></AdminGate>
  ),
});
